export const FETCH_TIRE_BRAND_REQUEST = 'TIRE_BRAND/FETCH/REQUEST';
export const FETCH_TIRE_BRAND_SUCCESS = 'TIRE_BRAND/FETCH/SUCCESS';
